var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgControlcenter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 3C0.947715 3 0.5 3.44772 0.5 4C0.5 4.55228 0.947715 5 1.5 5L1.5 3ZM15.5 13C16.0523 13 16.5 12.5523 16.5 12C16.5 11.4477 16.0523 11 15.5 11V13ZM14.5 4C14.5 5.10457 13.6046 6 12.5 6V8C14.7091 8 16.5 6.20914 16.5 4H14.5ZM12.5 2C13.6046 2 14.5 2.89543 14.5 4H16.5C16.5 1.79086 14.7091 -1.19209e-07 12.5 0V2ZM10.5 4C10.5 2.89543 11.3954 2 12.5 2V0C10.2909 1.19209e-07 8.5 1.79086 8.5 4H10.5ZM8.5 4C8.5 6.20914 10.2909 8 12.5 8V6C11.3954 6 10.5 5.10457 10.5 4H8.5ZM9.5 3L1.5 3L1.5 5L9.5 5V3ZM6.5 12C6.5 13.1046 5.60457 14 4.5 14V16C6.70914 16 8.5 14.2091 8.5 12H6.5ZM4.5 10C5.60457 10 6.5 10.8954 6.5 12H8.5C8.5 9.79086 6.70914 8 4.5 8V10ZM2.5 12C2.5 10.8954 3.39543 10 4.5 10V8C2.29086 8 0.5 9.79086 0.5 12H2.5ZM0.5 12C0.5 14.2091 2.29086 16 4.5 16V14C3.39543 14 2.5 13.1046 2.5 12H0.5ZM15.5 11H7.5V13H15.5V11Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgControlcenter);
export default __webpack_public_path__ + "static/media/controlcenter.35c06a3e3cacd0d63f50a439fc4c6ff2.svg";
export { ForwardRef as ReactComponent };